function activateFroala(el) {
  const fontFamily = {
    'proxima-nova, Helvetica, Arial, sans-serif': 'Default',
    'Arial,Helvetica,sans-serif': 'Arial',
    'Georgia,serif': 'Georgia',
    'Impact,Charcoal,sans-serif': 'Impact',
    'Tahoma,Geneva,sans-serif': 'Tahoma',
    "'Times New Roman',Times,serif": 'Times New Roman',
    'Verdana,Geneva,sans-serif': 'Verdana'
  };

  const htmlAllowedAttrsSafe = [
    'accept', 'accept-charset', 'accesskey', 'action', 'align', 'alt', 'async',
    'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset',
    'cellpadding', 'cellspacing', 'checked', 'cite', 'color', 'cols', 'colspan', 'content',
    'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default',
    'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form',
    'formaction', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon',
    'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max',
    'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'novalidate', 'open', 'optimum', 'pattern',
    'ping', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required',
    'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape',
    'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck',
    'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'width', 'wrap'
  ];

  const htmlAllowedTagsSafe = [
    'a', 'abbr', 'address', 'area', 'b', 'base', 'bdi', 'bdo',
    'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup',
    'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed',
    'fieldset', 'figcaption', 'figure', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'hgroup', 'hr', 'i', 'iframe', 'img', 'ins', 'kbd', 'keygen',
    'legend', 'li', 'link', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav',
    'object', 'ol', 'optgroup', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp',
    'rt', 'ruby', 's', 'samp', 'small', 'source', 'span',
    'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'];

  $(el).each(function() {
    const el = $(this);
    const safe = el.hasClass('froala-editor--safe');
    const options = { fontFamily: fontFamily, key: 'modxhG5H-9d==' };

    if (safe) {
      options['htmlAllowedAttrs'] = htmlAllowedAttrsSafe;
      options['htmlAllowedTags'] = htmlAllowedTagsSafe;
    }

    el.froalaEditor(options);
  });
}

export default activateFroala;
